import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import type {
    AssignToUserRequestParams } from "app/pages/sales-intelligence/sub-modules/assign-to-users";
import {
    useAssignDomainsToUserMutation
} from "app/pages/sales-intelligence/sub-modules/assign-to-users";

import type { FetchTopNLeadsDomainsParams } from "../queryFn/useFetchTopNLeadsDomains";
import { useFetchTopNLeadsDomains } from "../queryFn/useFetchTopNLeadsDomains";

type Params = Omit<AssignToUserRequestParams, "domains"> & FetchTopNLeadsDomainsParams;

export const useAssignTopNLeadsToUserMutation = (leadsType: LeadsType) => {
    const fetchTopNLeadsDomains = useFetchTopNLeadsDomains<Params>(leadsType);

    return useAssignDomainsToUserMutation<Params>(fetchTopNLeadsDomains);
};
